import { LevelType } from '../types/Level';
import { ORDERED_TYPES } from './planner';

// Rough dollars per step, from the design document. They are estimates to be corrected after real use:
// web search results and redrawn pictures add to the real cost.
export const COST = {
  planBase: 0.05,
  planPerLevel: 0.01,
  songResearch: 0.10,
  sayingScene: 0.02,
  funFact: 0.08,
  picture: 0.04,
  pictureCheck: 0.02,
};

export interface CostOptions {
  // A fun fact is found and checked for every level
  facts: boolean;
  // Songs and sayings get their picture drawn automatically (needs an image key)
  pictures: boolean;
}

export interface CostEstimate {
  claude: number;
  gemini: number;
  total: number;
}

const toCents = (amount: number): number => Math.round(amount * 100) / 100;

export const estimateCost = (counts: Partial<Record<LevelType, number>>, options: CostOptions): CostEstimate => {
  const levels = ORDERED_TYPES.reduce((sum, type) => sum + (counts[type] || 0), 0);
  if (levels <= 0) return { claude: 0, gemini: 0, total: 0 };

  const songs = counts[LevelType.WhatsTheSong] || 0;
  const sayings = counts[LevelType.KnownSentence] || 0;

  let claude = COST.planBase + COST.planPerLevel * levels;
  let gemini = 0;
  if (options.facts) claude += COST.funFact * levels;
  if (options.pictures) {
    claude += songs * (COST.songResearch + COST.pictureCheck) + sayings * (COST.sayingScene + COST.pictureCheck);
    gemini += (songs + sayings) * COST.picture;
  }

  return { claude: toCents(claude), gemini: toCents(gemini), total: toCents(claude + gemini) };
};

export const formatUsd = (amount: number): string => `$${amount.toFixed(2)}`;
